export default __webpack_public_path__ + "static/media/avatar-group-hover-last.ba706116.svg";